import "./index.css";
import Queuesimulation from "./simulator";

function App() {
  return (
    <div className="App">
      <Queuesimulation />
    </div>
  );
}

export default App;
